import { Component, Input } from '@angular/core';

@Component({
  selector: 'ct-excerpt',
  templateUrl: './excerpt.component.html'
})
export class ExcerptComponent {
  shortText: string;
  fullText: string;
  isExpanded = false;
  @Input() maxLength: number;
  @Input()
  set text(value: string) {
    this.shortText = value && value.length > this.maxLength ?
      value.substr(0, this.maxLength) :
      value;
    this.fullText = value;
  }
}
